import Box, { type BoxProps } from "@mui/material/Box";
import Button from "@mui/material/Button";

export interface StepNavigationProps {
  onBack: () => void;
  onNext: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
  nextLabel?: string;
  nextDisabled?: boolean;
  isSubmitting?: boolean;
  sx?: BoxProps["sx"];
}

const btnBase = {
  height: 40,
  borderRadius: 20,
  fontFamily: "'Inter', sans-serif",
  fontSize: 14,
  fontWeight: 400,
  textTransform: "none" as const,
  border: "none",
  backgroundColor: "black",
  color: "white",
  "&:hover": {
    backgroundColor: "#333",
    border: "none",
    color: "white",
  },
  "&.Mui-disabled": {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    color: "rgba(255, 255, 255, 0.6)",
  },
};

const StepNavigation = ({
  onBack,
  onNext,
  isFirstStep,
  isLastStep,
  nextLabel,
  nextDisabled = false,
  isSubmitting = false,
  sx,
}: StepNavigationProps): JSX.Element => {
  const label = nextLabel ?? (isLastStep ? "Submit" : "Next");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "row", sm: "row" },
        justifyContent: "space-between",
        gap: { xs: 1.5, sm: 2 },
        padding: { xs: "18px", md: "24px" },
        width: "100%",
        ...sx,
      }}
    >
      <Button
        type="button"
        onClick={onBack}
        disabled={isFirstStep || isSubmitting}
        fullWidth
        sx={{ ...btnBase, maxWidth: { sm: 160 } }}
      >
        Back
      </Button>

      <Button
        type="button"
        onClick={onNext}
        disabled={nextDisabled || isSubmitting}
        fullWidth
        sx={{ ...btnBase, maxWidth: { sm: 200 } }}
      >
        {isSubmitting ? "Please wait…" : label}
      </Button>
    </Box>
  );
};

export default StepNavigation;
